import React, { useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Accessory } from "../../../../powershadesApiTypes";
import placeholder from "../../../../assets/img/logos/primary/Powershades_Logo_Grayscale.png";

const highlightText = (text: string, highlight: string) => {
	if (!highlight.trim()) return <span>{text}</span>;
	const regex = new RegExp(`(${highlight})`, 'gi');
	const parts = text.split(regex);
	return (
		<span>
			{parts.map((part) =>
				(regex.test(part) ? <mark key={part}>{part}</mark> : <span key={part}>{part}</span>))}
		</span>
	);
};

const AccessoryCard: React.FC<{
	accessory: Accessory;
	selectedAccessories: { accessory: Accessory, quantity: number }[];
	setSelectedAccessories: React.Dispatch<React.SetStateAction<{ accessory: Accessory, quantity: number }[]>>;
	searchTerm: string;
	hidden?: boolean;
}> = ({ accessory, selectedAccessories, setSelectedAccessories, searchTerm, hidden = false }) => {
	const quantity = selectedAccessories.find((acc) => acc.accessory === accessory)?.quantity ?? 0;

	const [imgUrl, setImgUrl] = useState(`${process.env.BACKEND_ROOT}/api/Images/part_by_sku/${accessory.part_number}`);

	const showPlaceholder = () => setImgUrl(placeholder);

	return <div hidden={hidden} key={accessory.id} className="col">
		<Card className={`h-100 ${quantity ? 'border border-2 border-primary' : ''}`}>
			<Card.Img
				variant="top"
				src={imgUrl}
				alt={accessory.name}
				onError={showPlaceholder}
				style={{
					height: '200px',
					objectFit: 'contain',
					objectPosition: 'center',
					backgroundColor: 'white',
				}}
			/>
			<Card.Body className="d-flex flex-column">
				<Card.Title className="text-body fs-6">
					{highlightText(accessory.name, searchTerm)}
				</Card.Title>
				<Row className="mt-auto">
					<Col>
						{quantity
							? <Row>
								<Col xs="3" className="pe-0">
									<Button
										variant="danger"
										className="h-100 rounded w-100"
										onClick={() =>
											setSelectedAccessories((prev) =>
												prev.filter((acc) => acc.accessory !== accessory))}
									>
										<FontAwesomeIcon icon={faTrash} />
									</Button>
								</Col>
								<Col xs="9" className="ps-1">
									<Form.Control
										type="number"
										min={0}
										value={quantity}
										onChange={(e) => {
											const newQuantity = +e.target.value;
											setSelectedAccessories((prev) =>
												(newQuantity === 0
													? prev.filter((acc) => acc.accessory !== accessory)
													: prev.map((acc) =>
														(acc.accessory === accessory
															? { ...acc, quantity: newQuantity }
															: acc))));
										}}
									/>
								</Col>
							</Row>
							: <Button
								className="text-white form-control p-1 rounded"
								onClick={() =>
									setSelectedAccessories([...selectedAccessories, { accessory, quantity: 1 }])}
							>
								Add +
							</Button>}
					</Col>
				</Row>
			</Card.Body>
		</Card>
	</div>;
};

export default AccessoryCard;
